var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.entity.id)?_c('Delivery',{attrs:{"entity-type":_vm.BUSINESS_TYPE.ENTITY,"entity-id":+_vm.entity.id},scopedSlots:_vm._u([{key:"tabs",fn:function(){return [_c('EntityTabLinks')]},proxy:true}],null,false,1774175027)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }